const state = {
  pageLoadingState: false,
  processing: false,
  saving: false
  // fetching: false
};

const getters = {
  isProcessing: state => state.processing,
  // isFetching: state => state.fetching
};

const actions = {};

const mutations = {
  changeLoadingState(state, condition = true){
    state.pageLoadingState = condition;
  },
  flipProcessing(state, condition = true){
    state.processing = condition;
  },
  flipSaving(state, condition = true){
    state.saving = condition;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
